import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import type { PointerEvent } from 'react';
type TFloatingCardContext = Readonly<{
  handleDragStart: (e: PointerEvent<HTMLElement>) => void;
  isDragging: boolean;
  isPinned: boolean;
  togglePinned: () => void;
}>;
export const FloatingCardContext = createContext<Nullable<TFloatingCardContext>>(null);
export const useFloatingCardContext = () => {
  const context = useContext(FloatingCardContext);
  if (context == null) {
    throw new Error("FloatingCard subcomponents must be rendered inside FloatingCard.");
  }
  return context;
};
type Props = Readonly<{
  value: TFloatingCardContext;
  children: React.ReactNode;
}>;
export const FloatingCardContextProvider: React.FC<Props> = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <FloatingCardContext.Provider value={value}>{children}</FloatingCardContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};